// Customer-facing QuoteBid contact details. Single source for display copy.

export const SUPPORT_PHONE_DISPLAY = "(225) 347-4981";
